<template>    
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li><a href="#">首页</a></li>
                <li><a href="#">通讯录</a></li>
                <li><a href="#">添加联系人</a></li>
            </ul>
        </div>
        <div class="formbody">
            <div id="usual1" class="usual"> 
                <div class="itab">
                    <ul> 
                        <li><a href="#" @click="selectchange(0)" :class="{selected:list[0].isSelected}">基本信息</a></li> 
                        <li><a href="#" @click="selectchange(1)" :class="{selected:list[1].isSelected}">网络信息</a></li> 
                        <li><a href="#" @click="selectchange(2)" :class="{selected:list[2].isSelected}">公司信息</a></li> 
                        <li><a href="#" @click="selectchange(3)" :class="{selected:list[3].isSelected}">个人偏好</a></li> 
                        <li><a href="#" @click="selectchange(4)" :class="{selected:list[4].isSelected}">简要经历</a></li> 
                        <li><a href="#" @click="selectchange(5)" :class="{selected:list[5].isSelected}">家庭信息</a></li> 
                    </ul>
                </div> 
                <div id="tab1" class="tabson" v-show="list[0].isShow">
                    <ul class="forminfo">
    
                        <li><label>联系人姓名<b>*</b></label><input name="" v-model="name" type="text" class="dfinput" value=""  style="width:518px;"/></li>
                        
                        <li><label>手机号码<b>*</b></label><input name="" v-model="mphone1" type="text" class="dfinput" value=""  style="width:518px;"/></li>
                        
                        <li><label>座机号码<b></b></label><input name="" v-model="phone1" type="text" class="dfinput" value=""  style="width:518px;"/></li>
                        
                        <li><label>E-mail<b></b></label><input name="" v-model="email1" type="text" class="dfinput" value=""  style="width:518px;"/></li>
                        
                        <li><label>传真号<b></b></label><input name="" v-model="fax1" type="text" class="dfinput" value=""  style="width:518px;"/></li>
                        
                        <li><label>分组<b>*</b></label>
                        <div class="vocation">
                            <el-select v-model="txlGroupValue" placeholder="请选择">
                                <el-option
                                v-for="item in txlGroupList"
                                :key="item.groupid"
                                :label="item.groupname"
                                :value="item.groupid">
                                </el-option>
                            </el-select>
                        </div>
                        </li>
                        
                        <li><label>单位<b></b></label><input name="" v-model="company" type="text" class="dfinput" value=""  style="width:518px;"/></li>
                        
                        <li><label>部门<b></b></label><input name="" v-model="department" type="text" class="dfinput" value=""  style="width:518px;"/></li>
                    
                    
                        <li><label>&nbsp;</label><input class="sure" @click="savetxlcont()" type="button" value="确定">&nbsp;
                            <input class="cancel" type="button" value="取消">
                        </li>
                    </ul>
                </div>
                <div id="tab2" class="tabson" v-show="list[1].isShow">
    
                    <ul class="forminfo">
                    
                        <li><label>旺旺<b></b></label><input name="" type="text" v-model="w_ww" class="dfinput" value=""  style="width:518px;"/></li>
                        
                        <li><label>QQ<b></b></label><input name="" type="text" v-model="w_qq" class="dfinput" value=""  style="width:518px;"/></li>
                        
                        <li><label>MSN<b></b></label><input name="" type="text" v-model="w_msn" class="dfinput" value=""  style="width:518px;"/></li>
                        
                        <li><label>Skype<b></b></label><input name="" type="text" v-model="w_skype" class="dfinput" value=""  style="width:518px;"/></li>
                        
                        <li><label>个人网站<b></b></label><input name="" type="text" v-model="w_webpage" class="dfinput" value=""  style="width:518px;"/></li>
                        
                        <li><label>个人相册<b></b></label><input name="" type="text" v-model="w_photopage" class="dfinput" value=""  style="width:518px;"/></li>
                        
                        <li><label>网络U盘<b></b></label><input name="" type="text" v-model="w_webdisk" class="dfinput" value=""  style="width:518px;"/></li>
                    
                        <li><label>&nbsp;</label><input class="sure" @click="savetxlcont()" type="button" value="确定">&nbsp;
                            <input class="cancel" type="button" value="取消">
                        </li>
                    </ul>                    
                </div> 
                <div id="tab3" class="tabson" v-show="list[2].isShow">
    
                    <ul class="forminfo">
                    
                        <li><label>单位地址<b></b></label><input name="" v-model="c_address" type="text" class="dfinput" value=""  style="width:518px;"/></li>
                        
                        <li><label>单位邮编<b></b></label><input name="" v-model="c_postcode" type="text" class="dfinput" value=""  style="width:518px;"/></li>
                        
                        <li><label>单位电话<b></b></label><input name="" v-model="c_phone" type="text" class="dfinput" value=""  style="width:518px;"/></li>
                        
                        <li><label>单位传真<b></b></label><input name="" v-model="c_fax" type="text" class="dfinput" value=""  style="width:518px;"/></li>
                        
                        <li><label>单位网站<b></b></label><input name="" v-model="c_web" type="text" class="dfinput" value=""  style="width:518px;"/></li>
                        
                        <li><label>所在部门<b></b></label><input name="" v-model="c_department" type="text" class="dfinput" value=""  style="width:518px;"/></li>
                        
                        <li><label>担任职位<b></b></label><input name="" v-model="c_jobname" type="text" class="dfinput" value=""  style="width:518px;"/></li>
                        
                        <li><label>公司铭言<b></b></label><input name="" v-model="c_word" type="text" class="dfinput" value=""  style="width:518px;"/></li>
                    
                        <li><label>&nbsp;</label><input class="sure" @click="savetxlcont()" type="button" value="确定">&nbsp;
                            <input class="cancel" type="button" value="取消">
                        </li>
                    </ul>                    
                </div> 
                <div id="tab4" class="tabson" v-show="list[3].isShow">
    
                    <ul class="forminfo">                    
                        <li>
                        <label>性别<b></b></label>
                        <label><b><input name="" v-model="sex" type="radio" value="1" /></b> &nbsp;男</label>
                        <label><b><input name="" v-model="sex" type="radio" value="0" /></b> &nbsp;女</label></li>
                        
                        <li><label>生肖<b></b></label>
                        <div class="vocation">
                            <el-select v-model="srsxvalue" placeholder="请选择">
                                <el-option
                                v-for="item in srsxList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </div></li>
                        
                        <li><label>生日<b></b></label>
                        <div class="cityleft">
                            <el-date-picker
                            v-model="birthday"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择时间">
                        </el-date-picker>
                        </div></li>
                        
                        <li><label>星座<b></b></label>
                        <div class="vocation">
                            <el-select v-model="xzvalue" placeholder="请选择">
                                <el-option
                                v-for="item in xzList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                        </li>
                        
                        <li><label>爱好<b></b></label>
                            <el-select v-model="ahvalue" multiple placeholder="请选择">
                                <el-option
                                v-for="item in ahList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </li>
                        <li><label>&nbsp;</label><input class="sure" @click="savetxlcont()" type="button" value="确定">&nbsp;
                            <input class="cancel" type="button" value="取消">
                        </li>
                    </ul>                    
                </div>  

                <!--简要经历 -->
                <div id="tab5" class="tabson" v-show="list[4].isShow">    
                    <ul class="forminfo">                    
                        <li><label>毕业学校<b></b></label><input name="" v-model="school" type="text" class="dfinput" value=""  style="width:518px;"/></li>
                        
                        <li><label>所学专业<b></b></label><input name="" v-model="specialty" type="text" class="dfinput" value=""  style="width:518px;"/></li>
                        
                        <li><label>学历<b></b></label><div class="vocation">
                            <el-select v-model="xlvalue" placeholder="请选择">
                                <el-option
                                v-for="item in xlList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </div></li>
                        
                        <li><label>在职行业<b></b></label><div class="vocation">
                            <el-select v-model="zzhyvalue" placeholder="请选择">
                                <el-option
                                v-for="item in zzhyList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                        </li>
                        
                        <li><label>职位<b></b></label><div class="vocation">
                            <el-select v-model="zwvalue" placeholder="请选择">
                                <el-option
                                v-for="item in zwList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                        </li>
                        
                        <li><label>技术职称<b></b></label><div class="vocation">
                            <el-select v-model="selectTechnical" placeholder="请选择" v-on:change="getTechnical($event)">
                                <el-option
                                v-for="item in technicals"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                            <el-select v-model="selectPosition" placeholder="请选择" v-on:change="getPosition($event)">
                                <el-option
                                v-for="item in positions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                        </li>
                        
                        <li><label>资力等级<b></b></label><div class="vocation">
                            <el-select v-model="zldjvalue" placeholder="请选择">
                                <el-option
                                v-for="item in zldjList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                        </li>
                        
                        <li><label>&nbsp;</label><input class="sure" @click="savetxlcont()" type="button" value="确定">&nbsp;
                            <input class="cancel" type="button" value="取消">
                        </li>
                    </ul>                    
                </div>  

                <!-- 家庭信息 -->
                <div id="tab6" class="tabson" v-show="list[5].isShow">
    
                    <ul class="forminfo">
                    
                        <li><label>家庭地址<b></b></label><input name="" v-model="h_address" type="text" class="dfinput" value=""  style="width:518px;"/></li>
                        
                        <li><label>家庭邮编<b></b></label><input name="" v-model="h_postcode" type="text" class="dfinput" value=""  style="width:518px;"/></li>
                        
                        <li><label>家庭电话<b></b></label><input name="" v-model="h_phone" type="text" class="dfinput" value=""  style="width:518px;"/></li>
                        
                        <li><label>家庭传真<b></b></label><input name="" v-model="h_fax" type="text" class="dfinput" value=""  style="width:518px;"/></li>
                        
                        <li><label>家庭网站<b></b></label><input name="" v-model="h_web" type="text" class="dfinput" value=""  style="width:518px;"/></li>
                        
                    
                        <li><label>&nbsp;</label><input class="sure" type="button" @click="savetxlcont()" value="确定">&nbsp;
                            <input class="cancel" type="button" value="取消">
                            <!-- <a href='/txladd'>A标签添加通讯录</a>
                            <router-link to="/txlupload">router标签添加通讯录</router-link> -->
                        </li>
                    </ul>
                    
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import cookie from '@/components/cookie.vue'
export default {
    
    components : {
        'v-cookie' : cookie,
    },
    data(){
        return{
            list:[
                {isSelected:true,isShow:true,index:1},
                {isSelected:false,isShow:false,index:2},
                {isSelected:false,isShow:false,index:3},
                {isSelected:false,isShow:false,index:4},
                {isSelected:false,isShow:false,index:5},
                {isSelected:false,isShow:false,index:6},
            ],
            srsxList: this.GLOBAL.srsxList,
            srsxvalue:'',
            srList:this.GLOBAL.srList,
            birthday:'',
            xzList:this.GLOBAL.xzList,
            xzvalue:'',
            ahList:this.GLOBAL.ahList,
            ahvalue:[],
            //学历
            xlList: this.GLOBAL.xlList,
            xlvalue:'',
            //在职行业
            zzhyList:this.GLOBAL.zzhyList,
            zzhyvalue:'',
            //职位
            zwList:this.GLOBAL.zwList,
            zwvalue:'',
            technicals: this.GLOBAL.technicals,
            selectTechnical:'',
            positions:[],
            selectPosition:'',
            //资历等级
            zldjList:this.GLOBAL.zldjList,
            zldjvalue:'',
            //通讯录组
            txlGroupList:[],
            txlGroupValue:'',
            contid:this.$route.query.contid,
            name:'',    //联系人姓名
            mphone1:'', //手机号码
            phone1:'',  //座机号码
            email1:'',  //e-mail
            fax1:'',
            company:'',
            department:'',
            w_ww:'',
            w_qq:'',
            w_msn:'',
            w_skype:'',
            w_webpage:'',
            w_photopage:'',
            w_webdisk:'',
            c_address:'',
            c_postcode:'',
            c_phone:'',
            c_fax:'',
            c_web:'',
            c_department:'',
            c_jobname:'',
            c_word:'',
            sex:'1',
            school:'',
            specialty:'',
            h_address:'',
            h_postcode:'',
            h_phone:'',
            h_fax:'',
            h_web:'',
        }
    },
    mounted(){
        this.getTxlGroupList();
    },
    methods:{
        selectchange(index){
            this.list.forEach(function(obj){
                obj.isSelected = false;
                obj.isShow = false;
            });
            this.list[index].isSelected = true;
            this.list[index].isShow = true;
        },
        getTechnical: function(technical){
            this.positions = [];
            this.selectPosition = '';
            let tempPosition=[]; 
            for (var val of this.GLOBAL.allPositions){
            if (technical == val.technical){
                tempPosition.push({label: val.label, value: val.label})
            }
            }
            this.positions = tempPosition;
        },
        getPosition: function(positions){
            
        },
        getTxlGroupList(){
            var that = this
            let data = {'groupid':''}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/txl/gettxlgroup.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.txlGroupList = res.data.txlGroupList
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        savetxlcont(){
            if(this.name.trim().length < 1)
            {
                alert('联系人姓名不能为空！');
                return;
            }
            if(this.mphone1.trim().length < 1)
            {
                alert('手机号码不能为空！');
                return;
            }
            if(this.txlGroupValue == '')
            {
                alert('分组不能为空！');
                return;
            }
            let hobby = '';
            if(this.ahvalue.length > 0)
            {
                hobby = this.ahvalue.join(",");
            }
            let data = {'groupid':this.txlGroupValue,'name':this.name,'mphone1':this.mphone1,'phone1':this.phone1,'email1':this.email1,'fax1':this.fax1,'company':this.company,'department':this.department,'sex':this.sex,'effigy':this.srsxvalue,'starsite':this.xzvalue,'birthday':this.birthday,'calling':this.zzhyvalue,'job':this.zwvalue,'orank1':this.selectTechnical,'orank2':this.selectPosition,'rank':this.zldjvalue,'hobby':hobby,'school':this.school,'specialty':this.specialty,'degree':this.xlvalue,'h_address':this.h_address,'h_postcode':this.h_postcode,'h_phone':this.h_phone,'h_fax':this.h_fax,'h_web':this.h_web,'c_address':this.c_address,'c_postcode':this.c_postcode,'c_phone':this.c_phone,'c_fax':this.c_fax,'c_web':this.c_web,'c_department':this.c_department,'c_jobname':this.c_jobname,'c_word':this.c_word,'w_qq':this.w_qq,'w_msn':this.w_msn,'w_webpage':this.w_webpage,'w_photopage':this.w_photopage,'w_skype':this.w_skype,'w_webdisk':this.w_webdisk,'w_ww':this.w_ww}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/txl/inserttxlcont.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    alert('联系人添加成功！');
                }
                else
                {
                    alert(res.data.msg);
                }
            })
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/txl/txladd.vue